module.exports = __webpack_public_path__ + "img/141.d4ef8d1d.jpg";